import ProfilePersonalInformation from './ProfilePersonalInformation.component';

export default ProfilePersonalInformation;